import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IToggle } from 'modules/core/types';
import { Controller } from 'react-hook-form';
import { useUncontrolledInput } from 'modules/core/hooks';

import { ToggleContainer, ToggleUI } from './styles';

export const Toggle: FC<IToggle> = ({
  defaultChecked,
  icons,
  name,
  changeCallback,
  checked,
  disabled = false,
  showLabels = false,
}) => {
  const { t } = useTranslation();
  const { controlField, setValue } = useUncontrolledInput(name);

  const handleChange = useCallback(
    (e, onChange) => {
      onChange(e);
      setValue(e.target.name, e.target.checked);
      changeCallback && changeCallback(e);
    },
    [changeCallback, setValue],
  );

  const renderToggle = useCallback(
    ({ onChange, value }) => (
      <ToggleContainer>
        {showLabels && <span>{t('common.buttons.no')}</span>}
        <ToggleUI
          defaultChecked={defaultChecked}
          icons={icons}
          onChange={(event) => handleChange(event, onChange)}
          name={name}
          checked={checked !== undefined ? checked : value}
          disabled={disabled}
        />
        {showLabels && <span>{t('common.buttons.yes')}</span>}
      </ToggleContainer>
    ),
    [checked, defaultChecked, handleChange, icons, name, disabled, showLabels, t],
  );

  return <Controller name={name} control={controlField} render={renderToggle} />;
};
